import { render, staticRenderFns } from "./FormLayoutVertical.vue?vue&type=template&id=a07bd9c2&"
import script from "./FormLayoutVertical.vue?vue&type=script&lang=js&"
export * from "./FormLayoutVertical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports